// extracted by mini-css-extract-plugin
module.exports = {"container":"common-styles-container__2LdN-","error":"common-styles-error__ChYxf"};